interface ScoreRingProps {
  /** Текущий балл InBody (TOT_SCORE). */
  score: number;
  /** Максимум шкалы. По умолчанию 100. */
  max?: number;
  /** Диаметр кольца в px. */
  size?: number;
}

/**
 * Фиолетовое кольцо-прогресс с баллом InBody по центру.
 */
export default function ScoreRing({ score, max = 100, size = 120 }: ScoreRingProps) {
  const stroke = Math.max(6, Math.round(size / 14));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(1, (score || 0) / max));
  const offset = c * (1 - pct);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90 text-violet">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="rgba(255,255,255,0.1)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
      </svg>
      {/* Подпись «из 100» убрана: балл InBody может превышать 100. */}
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-2xl font-bold leading-none">{Math.round(score)}</span>
      </div>
    </div>
  );
}
